// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.categories[data-v-4b41fe15]{margin-top:32px}.page--title[data-v-4b41fe15]{margin:2em 0 .5em}.paginator .count[data-v-4b41fe15],.paginator .total[data-v-4b41fe15]{color:#9b0b54;font-weight:700;margin:0 .35em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
